<template>
  <div class="project-card">
    <div class="project-header">
      <h2 class="project-title">{{ project.title }}</h2>
      <div class="project-status" :class="getStatusClass(project.progress)">
        {{ project.progress }}
      </div>
    </div>
    
    <div class="project-content">
      <div class="project-info-grid">
        <div class="info-item">
          <div class="info-label">项目时间</div>
          <div class="info-value" v-html="project.time"></div>
        </div>
        
        <div class="info-item">
          <div class="info-label">项目简介</div>
          <div class="info-value" v-html="project.introduction"></div>
        </div>
        
        <div class="info-item">
          <div class="info-label">合作方</div>
          <div class="info-value" v-html="project.partner"></div>
        </div>
        
        <div class="info-item">
          <div class="info-label">技术服务支持</div>
          <div class="info-value" v-html="project.technology"></div>
        </div>
      </div>
    </div>
    
    <ImageGallery 
      v-if="project.images && project.images.length > 0" 
      :images="project.images" 
    />
  </div>
</template>

<script>
import ImageGallery from './ImageGallery.vue'

export default {
  name: 'ProjectCard',
  components: {
    ImageGallery
  },
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  methods: {
    getStatusClass(status) {
      return {
        'status-completed': status === '已完结',
        'status-ongoing': status === '进行中'
      }
    }
  }
}
</script>

<style scoped>
.project-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 20px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.project-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #004080, #0066cc, #004080);
  background-size: 200% 100%;
  animation: shimmer 3s ease-in-out infinite;
}

@keyframes shimmer {
  0%, 100% { background-position: 200% 0; }
  50% { background-position: -200% 0; }
}

.project-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.project-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1.5rem;
  gap: 1rem;
}

.project-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #004080;
  margin: 0;
  line-height: 1.3;
  flex: 1;
}

.project-status {
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 600;
  white-space: nowrap;
  text-align: center;
  min-width: 80px;
}

.status-completed {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
}

.status-ongoing {
  background: linear-gradient(135deg, #f59e0b, #d97706);
  color: white;
}

.project-content {
  margin-bottom: 1.5rem;
}

.project-info-grid {
  display: grid;
  gap: 1.5rem;
}

.info-item {
  background: rgba(255, 255, 255, 0.7);
  padding: 1.25rem;
  border-radius: 12px;
  border-left: 4px solid #004080;
  transition: all 0.3s ease;
}

.info-item:hover {
  background: rgba(255, 255, 255, 0.9);
  transform: translateX(5px);
}

.info-label {
  font-weight: 700;
  color: #004080;
  margin-bottom: 0.5rem;
  font-size: 1rem;
}

.info-value {
  color: #374151;
  line-height: 1.6;
  font-size: 0.95rem;
}

@media (max-width: 768px) {
  .project-card {
    padding: 1.5rem;
    margin-bottom: 1.5rem;
  }
  
  .project-header {
    flex-direction: column;
    align-items: stretch;
  }
  
  .project-title {
    font-size: 1.25rem;
    margin-bottom: 1rem;
  }
  
  .project-status {
    align-self: flex-start;
  }
}
</style>